import { getPreviousMonday, get_days, get_weeks, get_months, get_years } from './dates'

import { DateTime } from "luxon";

export function checkString(data) {
  if (typeof data !== "undefined") {
    if (data) {
      if (data.trim() !== "") {
        return true;

      }
    }
  }
  return false;
}


export function checkArray(data) {

  if (typeof data !== "undefined") {
    if (data.length > 0) {
      return true;
    }
  }

  return false;
}

export function removeCommonValues(arr1, arr2) {
  const set1 = new Set(arr1);

  for (let i = 0; i < arr2.length; i++) {
    if (set1.has(arr2[i])) {
      arr1.splice(arr1.indexOf(arr2[i]), 1);

      arr2.splice(i, 1);

      i--;
    }
  }
}

export function removeValueFromArray(value, array) {
  const index = array.indexOf(value);
  if (index !== -1) {
    array.splice(index, 1);
  }
  return array;
}


export function createTopFilters(topFilter, language) {
  if (typeof topFilter !== "undefined") {

    const top_filter = {
      id: 9999999,
      position: 'top',
      type: topFilter.type,
      name: topFilter.populate,
      title: topFilter.populate,
      value: "all",
      all_text: topFilter.all_text,
      choose_text: topFilter.choose_text,
      // today: topFilter.today,
      or: false,
    }
    if (topFilter.type === "date") {



      if (topFilter.populate === "auto") {

        const options = get_days(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next 2 weeks";

        top_filter.value = DateTime.now()
          .setZone("Europe/London")
          .startOf("day")
          .toSeconds();
      }

      if (topFilter.populate === "daily") {

        const options = get_days(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next 2 weeks";

        top_filter.value = DateTime.now()
          .setZone("Europe/London")
          .startOf("day")
          .toSeconds();
      }

      if (topFilter.populate === "weekly") {
        let today = DateTime.now().setZone("Europe/London").startOf("day");

        const options = get_weeks(today.toSeconds());
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few weeks";

        if (today.weekday !== 1) {
          today = getPreviousMonday(today.toJSDate()); // re-use helper
        }

        top_filter.value = today.toSeconds();
      }

      if (topFilter.populate === "monthly") {
        const today = DateTime.now().setZone("Europe/London").startOf("day");

        const options = get_months();
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few months";

        const topFilterDate = today.startOf("month");
        console.log(topFilterDate.toSeconds())
        top_filter.value = topFilterDate.toSeconds();
      }

      if (topFilter.populate === "yearly") {
        const currentYear = DateTime.now().setZone('Europe/London').year;
        const topFilterDate = DateTime.local(currentYear, 1, 1, { zone: 'Europe/London' }).startOf('day');

        const options = get_years();
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few years";

        top_filter.value = topFilterDate.toSeconds();
      }



    } else {
      top_filter.options = [...topFilter.values];
      top_filter.value = "all";
    }

    if (language.top_nav_title.length) {
      top_filter.title = language.top_nav_title;

    }



    return top_filter;
  } else {
    return "";
  }
}
